import * as Cookies from '../utils/cookies';
import axios from 'axios';

export async function editPlayer(playerId, profile_pic, grade, school, sentence) {
  const token = Cookies.getToken();


  const formData = new FormData();
  if (profile_pic !== null) {
    formData.append('profile_pic', profile_pic);
  }
  formData.append('grade', grade);
  if (school) {
    formData.append('school', school);
  }
  formData.append('school', school);
  if (sentence) {
    formData.append('sentence', sentence);
  }



  const res = await axios({
    method: 'PATCH',
    url: process.env.REACT_APP_API_URL + `/api/users/players/${playerId}/`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  });

  return res;
}
